import React, { Component } from 'react'
import './evaluations.css'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'

export default class OneOnOneSessionEvaluation extends Component {
  constructor(props) {
    super(props)
    var session = _.find(this.props.sessions.sessions, {id: parseInt(props.match.params.id, 10)})
    var one_on_one_meeting = _.find(session.one_on_one_meetings, {id: parseInt(props.match.params.one_on_one_meeting_id, 10)})
    if(one_on_one_meeting.evaluation_completed) {
      this.props.history.push('/evaluations')
    }
    this.state = {
      session: session,
      one_on_one_meeting: one_on_one_meeting,
      commentText: '',
      OverallRating: 0
    }
    this.handleRadio = this.handleRadio.bind(this)
    this.props.setActiveTab('evaluations', false)
    window.trackPage('P2PEvaluationDetailScreen', props.match.params.id)
  }

  componentDidMount() {
    window.scrollTo(0,0)
  }

  updateComment(e){
    this.setState({
      commentText: e.target.value
    })
  }

  star(number) {
    this.setState({OverallRating: number})
    this.forceUpdate()
  }

  submit(e) {
    e.currentTarget.disabled = true
    if(this.state.OverallRating === undefined || this.state.OverallRating === 0 ) {
      this.props.flashMessage({
        message: getLabel('session_rating_required'),
        type: 'error'
      })
      e.currentTarget.disabled = false
    } else {
      var data = {
        event_one_on_one_meeting_survey:
          {
            event_one_on_one_meeting_id: this.state.one_on_one_meeting.id,
            rating: this.state.OverallRating,
            comments: this.state.commentText
          }
      }
      this.props.postResource({ key: 'one_on_one_session_evaluation', data: data, session: this.state.session, callback: () => {
        this.props.history.push('/evaluations')
      }})
    }
  }

  cancel() {
    window.history.back()
  }

  handleRadio(event) {
    const boo = event.currentTarget.value === 'true' ? true: false
    this.setState({ requestFollowup: boo })
  }

  typeAndLocation() {
    let sessionType = this.state.session.session_type
    // let meetingLocation = this.state.one_on_one_meeting.meeting_location
    if (sessionType.endsWith('s')) {
      sessionType = sessionType.substr(0, sessionType.length - 1)
    }
    // if (meetingLocation && Number(meetingLocation)) {
    //   meetingLocation = `-- Table #${meetingLocation}`
    // }
    // return `${sessionType} ${meetingLocation}`
    return `${sessionType}`
  }

  participantOrHidden() {
    const users = JSON.parse(localStorage.getItem('users')).event_users
    var otherUser = users?.find((user) => {
      return user?.user_id === this.state.one_on_one_meeting?.participant_user?.id
    })
    return otherUser ? `${otherUser.first_name} ${otherUser.last_name}, ${otherUser.organization_name}` : 'User hidden'
  }

  render() {
    if(!this.state.session) {
      return (
        <div>
          no session found
        </div>
      )
    } else {
      return (
        <div>
          <TitleBar title='Peer-to-Peer Evaluation' />
          <h2>{this.participantOrHidden()}</h2>
          <h6>{this.state.one_on_one_meeting.formatted_display_date}</h6>
          <h6>{this.typeAndLocation()}</h6>
          <br />
          <p>{getLabel('rating_instructions')}</p>
          <h5>How would you rate this meeting?</h5>
          <i onClick={() => this.star(1)} className={(this.state.OverallRating >= 1 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => this.star(2)} className={(this.state.OverallRating >= 2 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => this.star(3)} className={(this.state.OverallRating >= 3 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => this.star(4)} className={(this.state.OverallRating >= 4 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => this.star(5)} className={(this.state.OverallRating >= 5 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <br /><br />
          { (this.state.session.event_session_speakers.length > 0) && <h4>{getLabel('session_rate_speakers')}</h4> }
          <br />
          <label>{getLabel('additional_comments')}</label>
          <textarea className="form-control" placeholder={getLabel('additional_comment_placeholder')} value={ this.state.commentText } onChange={ this.updateComment.bind(this) } />
          <div className="center">
            <button className="standard" onClick={this.submit.bind(this)}>{getLabel('submit')}</button>
            <br />
            <button className="cancel" onClick={this.cancel.bind(this)}>{getLabel('cancel')}</button>
          </div>
        </div>
      )
    }
  }
}
